// So'm summasini yagona ko'rinishda chiqaradi: "150 000 so'm". Raqam guruhlari oddiy
// bo'shliq bilan ajratiladi (ru-RU NBSP o'rniga) — chaqiruvchi `white-space: nowrap` beradi.
export function formatSom(value) {
  if (value == null || value === '' || Number.isNaN(Number(value))) return '—';
  const n = Math.round(Number(value));
  const grouped = String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${n < 0 ? '-' : ''}${grouped} so'm`;
}
